module.exports = "/_next/static/images/8fa0c0328ebe0a2b3bedb928dd026f5d-slide3mobile.jpg.webp";